import { render } from "./AddWidgetPopup.vue?vue&type=template&id=4393d464&scoped=true"
import script from "./AddWidgetPopup.vue?vue&type=script&lang=js"
export * from "./AddWidgetPopup.vue?vue&type=script&lang=js"

import "./AddWidgetPopup.vue?vue&type=style&index=0&id=4393d464&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4393d464"],['__file',"src/containers/widget/AddWidgetPopup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4393d464"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4393d464', __exports__)) {
    api.reload('4393d464', __exports__)
  }
  
  module.hot.accept("./AddWidgetPopup.vue?vue&type=template&id=4393d464&scoped=true", () => {
    api.rerender('4393d464', render)
  })

}


export default __exports__